<template>
  <!-- Ergebnis beim Servicepartner: grün „repariert · B" (mit Grading),
       rot „nicht repariert" — dieselbe Machart wie im Partnerportal. -->
  <span
    v-if="outcome !== null"
    class="badge partner-outcome"
    :class="outcome === 'repaired' ? 'is-repaired' : 'is-not-repaired'"
  >{{ outcome === 'repaired' ? (grading ? `repariert · ${grading}` : 'repariert') : 'nicht repariert' }}</span>
</template>

<script setup lang="ts">
defineProps<{
  outcome: 'repaired' | 'not_repaired' | null;
  grading?: string | null;
}>();
</script>

<style scoped>
.partner-outcome {
  font-weight: 600;
}
.partner-outcome.is-repaired {
  background: #dcfce7;
  color: #166534;
}
.partner-outcome.is-not-repaired {
  background: #fee2e2;
  color: #b91c1c;
}
</style>
